import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import useDataFetch from "../../hooks/useDataFetch";
import styles from "./UpdatePassword.module.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useSectionsRefs} from "../../components/mainWrapper/MainWrapper";
import CustomTextField from "../../components/customMUIComponents/CustomTextField";
import {Alert, Button, Grid2} from "@mui/material";
import useDataPut from "../../hooks/useDataPut";

interface UpdatePasswordResponse {
    uid: string,
}

const UpdatePassword = () => {

    const {
        setNavItems,
        setDisplayRegisterSocietyButton,
        setDisplayLoginButton,
        setDisplayMobileMenu
    } = useSectionsRefs();

    useEffect(() => {
        setNavItems([]);
        setDisplayRegisterSocietyButton(false);
        setDisplayLoginButton(false);
        setDisplayMobileMenu(false);
        window.scrollTo(0, 0);
    }, [setDisplayLoginButton, setNavItems, setDisplayRegisterSocietyButton, setDisplayMobileMenu]);

    const [searchParams] = useSearchParams();
    const uid = searchParams.get("uid")
    const passwordUpdated = searchParams.get("passwordUpdated")

    const [password, setPassword] = useState<string>('');
    const [passwordConfirmation, setPasswordConfirmation] = useState<string>('');

    const {
        data,
        error,
    } = useDataFetch<UpdatePasswordResponse>(`/update-password?uid=${uid}`, false, !!uid)

    const {putDataPromise} = useDataPut<void>('/update-password', undefined, false, false, false);

    const [formError, setFormError] = useState<string>('');

    const handleResetPassword = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (password.length < 8) {
            setFormError("Le mot de passe doit faire au moins 8 caractères.")
            return;
        }
        if (password !== passwordConfirmation) {
            setFormError("Les mots de passe ne correspondent pas.")
        }

        putDataPromise(undefined, {
            uid: uid,
            newPassword: password
        }).then((response) => {
            window.location.href = 'https://looty.ch/update-password?passwordUpdated=true'
        })
    }

    return (
        <>
            <Box sx={{
                width: "100%",
                backgroundColor: 'primary.main',
                alignContent: 'center'
            }}>

                <Box
                    sx={{
                        backgroundColor: "primary.main",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div className={styles.content}>
                        <div className={styles.realContent}>
                            <Typography
                                variant={"secondVariant"}
                                sx={{
                                    fontSize: {xs: 22, sm: 26, md: 30},
                                    mb: 3,
                                }}
                            >
                                Réinitialisation du mot de passe
                            </Typography>

                            {(passwordUpdated) && (<div>
                                <Typography
                                    variant={"secondVariant"}
                                    sx={{
                                        fontSize: {xs: 16, sm: 18, md: 20},
                                        mb: 3,
                                    }}
                                >
                                    Ton mot de passe a bien été mis à jour. Continue l'aventure sur <a href={"https://looty.ch"}>looty.ch</a>
                                </Typography>
                            </div>)}


                            {(!passwordUpdated && data) && <div>

                                <Typography
                                    variant={"secondVariant"}
                                    sx={{
                                        fontSize: {xs: 16, sm: 18, md: 20},
                                        mb: 3,
                                    }}
                                >
                                    Saisis ton nouveau mot de passe
                                </Typography>

                                <form onSubmit={(e) => handleResetPassword(e)}>
                                    <Grid2 container p={4}>
                                        <Grid2 size={12}>
                                            <CustomTextField
                                                value={password}
                                                label="Nouveaut mot de passe"
                                                mb={4}
                                                type="password"
                                                required
                                                setField={setPassword}
                                                variant="outlined"
                                            />
                                        </Grid2>

                                        <Grid2 size={12}>
                                            <CustomTextField
                                                value={passwordConfirmation}
                                                label="Confirmation mot de passe"
                                                mb={4}
                                                type="password"
                                                required
                                                setField={setPasswordConfirmation}
                                                variant="outlined"
                                            />
                                        </Grid2>


                                        <Grid2 size={12}>
                                            <Button
                                                fullWidth
                                                variant={"secondVariant"}
                                                type={"submit"}
                                            >
                                                Confirmer
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </form>

                                {formError && (
                                    <Alert
                                        severity="error"
                                        sx={{mb: 4}}
                                    >
                                        {formError}
                                    </Alert>
                                )}

                            </div>
                            }

                            {(!uid && !passwordUpdated) &&
                                <div>
                                    <Typography
                                        variant={"secondVariant"}
                                        sx={{
                                            fontSize: {xs: 16, sm: 18, md: 20},
                                            mb: 3,
                                        }}
                                    >
                                        Paramètre invalide, veuillez vérifier l'url
                                    </Typography>
                                </div>
                            }

                            {(!passwordUpdated && (!uid || (error && error.status === 404))) &&
                                <div>
                                    <Typography
                                        variant={"secondVariant"}
                                        sx={{
                                            fontSize: {xs: 16, sm: 18, md: 20},
                                            mb: 3,
                                        }}
                                    >
                                        Ce lien n'est pas valide.
                                    </Typography>
                                </div>
                            }

                            {(!passwordUpdated && (error && error.status === 410)) &&
                                <div>
                                    <Typography
                                        variant={"secondVariant"}
                                        sx={{
                                            fontSize: {xs: 16, sm: 18, md: 20},
                                            mb: 3,
                                        }}
                                    >
                                        Ce lien a déjà été utilisé.
                                    </Typography>
                                </div>
                            }
                        </div>
                    </div>
                </Box>
            </Box>
        </>
    )
        ;
}

export default UpdatePassword